export const enumChooseSubscription = {
    INCONNU : 0,
    FREEMIUM : 1,
    CASUAL: 2,
    REGULAR : 3,
    GRANDCOMPTE : 4,
    ESSAI : 5,
    OFFRES120 : 6,
}